//# sourceMappingURL=utils.mjs.map
/// <reference types="./utils.d.mts" />
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $pair from "../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import { toJSON as to_json } from "../common.ffi.mjs";
import { toList, CustomType as $CustomType, isEqual } from "../gleam.mjs";

export { to_json };

export class QualificationMatrixRow extends $CustomType {
  constructor(title, content, order) {
    super();
    this.title = title;
    this.content = content;
    this.order = order;
  }
}
export const QualificationMatrixRow$QualificationMatrixRow = (title, content, order) =>
  new QualificationMatrixRow(title, content, order);
export const QualificationMatrixRow$isQualificationMatrixRow = (value) =>
  value instanceof QualificationMatrixRow;
export const QualificationMatrixRow$QualificationMatrixRow$title = (value) =>
  value.title;
export const QualificationMatrixRow$QualificationMatrixRow$0 = (value) =>
  value.title;
export const QualificationMatrixRow$QualificationMatrixRow$content = (value) =>
  value.content;
export const QualificationMatrixRow$QualificationMatrixRow$1 = (value) =>
  value.content;
export const QualificationMatrixRow$QualificationMatrixRow$order = (value) =>
  value.order;
export const QualificationMatrixRow$QualificationMatrixRow$2 = (value) =>
  value.order;

export const default_tags = /* @__PURE__ */ toList([
  "Engineering",
  "Product",
  "Security",
  "Sales",
  "Legal",
  "Marketing",
  "Other",
]);

export const default_qm_rows = /* @__PURE__ */ toList([
  /* @__PURE__ */ new QualificationMatrixRow(
    "Executive Buyer / Decision Maker Relationship",
    "Have we had a conversation with the executive buyer? #(Please note: The executive buyer is the person with the decision-making power and owns the budget for this project.)",
    0,
  ),
  /* @__PURE__ */ new QualificationMatrixRow(
    "Friend / Champion Relationship",
    "Do we have a good relationship with someone who has influence with the executive buyer / decision maker? Will they help us prep for meetings? Will they provide us with insight on how to win the RFP?",
    1,
  ),
  /* @__PURE__ */ new QualificationMatrixRow(
    "Reasonable Timeline",
    "Is the response timeline more than three weeks? Do we have enough time to respond with a high quality proposal that doesn't require late nights and weekends?\n    Reason for Change	What is the reason the customer is going out to RFP? What problems are they trying to solve? Are they moving on from their incumbent provider?",
    2,
  ),
  /* @__PURE__ */ new QualificationMatrixRow(
    "Confirmed Budget",
    "Does the customer have a confirmed budget for this project?",
    3,
  ),
  /* @__PURE__ */ new QualificationMatrixRow(
    "Solution Fit",
    "Is the solution the customer is looking for something you can fulfill? Can you provide 80% of the features or services they're asking for?",
    4,
  ),
  /* @__PURE__ */ new QualificationMatrixRow(
    "Purchasing Process",
    "Do you know the customer's purchasing process, going from RFP to signature? Do your contacts within the company know what it is?",
    5,
  ),
  /* @__PURE__ */ new QualificationMatrixRow(
    "Legal Compatability",
    "Is there anything in their RFP T&Cs that you can't agree with? Can you confirm with your legal team they can overcome any potential hurdle with the customer?",
    6,
  ),
  /* @__PURE__ */ new QualificationMatrixRow(
    "Competition",
    "Do you know who the competitors are? Do you have a good value proposition against each competitor?",
    7,
  ),
]);

export function find_list_element_index(types, value) {
  let _pipe = types;
  let _pipe$1 = $list.find(_pipe, (v) => { return isEqual(v[1], value); });
  return $result.map(_pipe$1, $pair.first);
}
